import React from 'react';
import { Alert } from 'react-bootstrap';
import { nl2br } from 'helpers';
import { useSelector } from 'react-redux';
/**
 * メッセージコンポーネント
 */
const Message = () => {
  const messageState = useSelector((state) => state.message);
  if (!messageState.messages) {
    return '';
  } else {
    return (
      <div>
        {messageState.messages.map((data, index) => {
          return (
            <div key={index} className='form-group_alert' style={{marginTop: 0}}>
              {data.type && data.text && <Alert variant={data.type} >{nl2br(data.text)}</Alert> }
            </div>
          );
        })}
      </div>
    );
  }
};

export default Message;